module.exports = [{"fromPath":"/","isPermanent":true,"redirectInBrowser":true,"toPath":"/the-realist/the-book/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/redirects.json
// module id = 433
// module chunks = 231608221292675